import { createSlice } from '@reduxjs/toolkit';
import { getLoggedInUser, signIn, join, notification } from './actions';
import { constants } from 'src/constants';
import { clearStorage, retrieveData, storeData } from 'src/helper/storageHelper';

const initialState = {
  user: null,
  notificationCount: 0,
  token: retrieveData(constants.authToken),
  status: {
    user: { loading: true, errorMessage: '' },
    join: { loading: false, errorMessage: '' },
    signIn: { loading: false, errorMessage: '' },
    common: { loading: false, errorMessage: '' },
  },
  drivers: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: () => initialState,
    signOut: (state) => {
      state.user = null;
      clearStorage();
      state.token = '';
    },
    setDrivers: (state, action) => {
      state.drivers = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // getLoggedInUser
      .addCase(getLoggedInUser.pending, (state) => {
        state.status.user.loading = true;
      })
      .addCase(getLoggedInUser.fulfilled, (state, action) => {
        state.status.user.loading = false;
        state.user = action.payload.data;
      })
      .addCase(getLoggedInUser.rejected, (state, action) => {
        state.status.user.loading = false;
        state.status.user.errorMessage = action.error.message;
      })
      // postSignin
      .addCase(signIn.pending, (state) => {
        state.status.signIn.loading = true;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.status.signIn.loading = false;
        state.token = action.payload.data.token;
        storeData(constants.authToken, action.payload.data.token);
      })
      .addCase(signIn.rejected, (state, action) => {
        state.status.signIn.loading = false;
        state.status.signIn.errorMessage = action.error.message;
      })
      //post join in
      .addCase(join.pending, (state) => {
        state.status.signIn.loading = true;
      })
      .addCase(join.fulfilled, (state, action) => {
        state.status.signIn.loading = false;
        state.token = action.payload.data.token;
        storeData(constants.authToken, action.payload.data.token);
      })
      .addCase(join.rejected, (state, action) => {
        state.status.signIn.loading = false;
        state.status.signIn.errorMessage = action.error.message;
      })
      //notification
      .addCase(notification.pending, (state) => {
        state.status.common.loading = true;
      })
      .addCase(notification.fulfilled, (state, action) => {
        state.notificationCount = action.payload.data;
        state.status.common.loading = false;
      })
      .addCase(notification.rejected, (state, action) => {
        state.status.common.errorMessage = action.error.message;
        state.status.common.loading = false;
      });
  },
});

export const { reset, signOut, setDrivers } = authSlice.actions;

export default authSlice.reducer;
